import { LicenseFeature } from '../../types';

export const baseOfficeFeatures: LicenseFeature[] = [
  { name: 'Exchange Online', included: false },
  { name: 'SharePoint Online', included: false },
  { name: 'Teams', included: false },
  { name: 'OneDrive for Business', included: false },
  { name: 'Web versions of Office', included: false },
  { name: 'Desktop Office apps', included: false },
];

export const baseSecurityFeatures: LicenseFeature[] = [
  { name: 'Basic Security', included: false },
  { name: 'Advanced Security', included: false },
  { name: 'Mobile Device Management', included: false },
  { name: 'Azure Information Protection', included: false },
  { name: 'Conditional Access', included: false },
];

export const baseCollaborationFeatures: LicenseFeature[] = [
  { name: 'Microsoft Lists', included: false },
  { name: 'Microsoft Stream', included: false },
  { name: 'Microsoft Planner', included: false },
  { name: 'Microsoft Forms', included: false },
  { name: 'Yammer', included: false },
];